// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ojyesncvjabghxucgpch.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9qeWVzbmN2amFiZ2h4dWNncGNoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ1NTI1MTMsImV4cCI6MjA2MDEyODUxM30.XkX1Xhk5QUzFpwb4yltTHZhsmzE9VAUA9XUQXPWf_Ns";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);